import * as m from "@/paraglide/messages";

import { PRICE_KEYS, stripePriceMap } from "./stripe-plans";

// ── Plan Definitions ─────────────────────────────────────────────────────────
// Returns i18n'd plans — call at render time to pick up the current locale.

export function getPlans(): Plan[] {
	return [
		{
			id: "free",
			name: m.pricing_freeName(),
			label: m.plan_freeLabel(),
			priceId: "",
			price: "$0",
			yearlyPrice: "$0",
			description: m.plan_freeDesc(),
			features: [
				m.plan_freeFeature1(),
				m.plan_freeFeature2(),
				m.plan_freeFeature4(),
				m.plan_freeFeature3(),
			],
			cta: m.pricing_freeCta(),
		},
		{
			id: "pro",
			name: m.pricing_proName(),
			label: m.plan_proLabel(),
			priceId: stripePriceMap[PRICE_KEYS.PRO_MONTHLY],
			annualDiscountPriceId: stripePriceMap[PRICE_KEYS.PRO_YEARLY],
			price: "$9.99",
			yearlyPrice: "$99.99",
			description: m.plan_proDesc(),
			features: [
				m.plan_proFeature3(),
				m.plan_proFeature4(),
				m.plan_proFeature5(),
				m.plan_proFeature6(),
			],
			cta: m.pricing_proCta(),
			popular: true,
			highlighted: true,
		},
		{
			id: "max",
			name: m.pricing_teamName(),
			label: m.plan_maxLabel(),
			priceId: stripePriceMap[PRICE_KEYS.MAX_MONTHLY],
			annualDiscountPriceId: stripePriceMap[PRICE_KEYS.MAX_YEARLY],
			price: "$99.99",
			yearlyPrice: "$999.99",
			description: m.plan_maxDesc(),
			features: [
				m.plan_maxFeature1(),
				m.plan_maxFeature2(),
				m.plan_maxFeature3(),
				m.plan_maxFeature4(),
			],
			cta: m.pricing_teamCta(),
		},
	];
}

/** Get a single plan by id — call at render time for i18n */
export function getPlanByName(name: string) {
	return getPlans().find((p) => p.id === name);
}

/** Plan IDs that grant "pro" access (i.e. all paid plans). Server-safe — no i18n. */
export function getPaidPlanIds(): string[] {
	return getPlans()
		.filter((p) => p.id !== "free")
		.map((p) => p.id);
}

// ── Types ────────────────────────────────────────────────────────────────────

export type Plan = {
	/** Plan identifier used for Stripe upgrade (e.g. "free", "pro", "max") */
	id: string;
	name: string;
	label: string;
	priceId: string;
	annualDiscountPriceId?: string;
	price: string;
	yearlyPrice?: string;
	description: string;
	features: string[];
	cta: string;
	popular?: boolean;
	highlighted?: boolean;
};
